import React, { useContext as useContextCore } from 'react'

const context = React.createContext(null)
const CoreProvider = context.Provider

export const Provider = ({ children, ...props }) => {
  const [newTasks, setNewTasks] = React.useState([])

  return <CoreProvider value={{ ...props, newTasks, setNewTasks }}>{children}</CoreProvider>
}

export const useContext = () => useContextCore(context)
